// extracted by mini-css-extract-plugin
export default {"world-map":"world-map-iD3nS"};